import { useEffect, useState } from 'react';
const useChartTable = (sizeChart, setCountrySize, setMonclerSizes) => {
    const [localTable, setTable] = useState();
    useEffect(() => {
        var _a, _b;
        if (sizeChart && sizeChart.content) {
            const localtable = {};
            sizeChart.content.forEach((chart, i) => {
                let chartTitle = chart.title ? chart.title : 'cm';
                const decodedMap = decodeURI(sizeChart.content[i].content);
                localtable[chartTitle] = decodedMap.split('\n').map((el) => el.split('\t'));
            });
            setTable(localtable);
        }
        if (sizeChart && sizeChart.sizechartdata) {
            const sizeMoncler = sizeChart.sizechartdata.countries.find((c) => c.id == 'MONCLER');
            sizeMoncler.rawValues = sizeMoncler.values.map((v) => v.toString().replace(/[.,]/g, ''));
            let sizeCountry = (_a = sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.sizechartdata) === null || _a === void 0 ? void 0 : _a.countries.find((el) => el.id == window.country);
            if (!sizeCountry) {
                let fallbackCountryID;
                if (sizeChart.sizechartdata.defaultSizeConversion) {
                    fallbackCountryID = (_b = sizeChart.sizechartdata.defaultSizeConversion.find((s) => s.id == window.country)) === null || _b === void 0 ? void 0 : _b.defaultSizeConversion;
                }
                sizeCountry = sizeChart.sizechartdata.countries.find((c) => c.id == (fallbackCountryID || 'IT')) || sizeChart.sizechartdata.countries.find((c) => c.id !== 'MONCLER'); // IT acts as first fallback (OE-20412), then first of array (OE-29545)
            }
            setCountrySize(sizeCountry);
            if (setMonclerSizes) {
                setMonclerSizes(sizeMoncler);
            }
        }
    }, [sizeChart]);
    return localTable;
};
export default useChartTable;
